// @core/api/endpoints/form/batch_get_entity_forms.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BatchGetEntityFormsRequest,
  BatchGetEntityFormsResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Batch get entity forms
 * Returns form aspect data for multiple entities. Used by BFF for list views with form status.
 */
export async function BatchGetEntityForms(
  data: BatchGetEntityFormsRequest,
  options?: RequestOptions
): Promise<BatchGetEntityFormsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/form/batch`;
  const requestOptions = options;
  return client.post<BatchGetEntityFormsResponse>(requestPath, data, requestOptions);
}
